import * as React from 'react';
import { TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Link } from '@leagueplatform/routing';
import { ResponsiveHeaderNav } from '@leagueplatform/solutions-foundation';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import logoWithText from 'assets/HealthCoLogo.svg';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useUserSettingsLinksConfig } from 'components/header-nav/use-user-settings-links-config.hook';
import { useNavLinksList } from './use-nav-links-list.hook';

const Logo = () => {
  const { formatMessage } = useIntl();
  return (
    <TextAction
      as={Link}
      to={APP_MANAGED_ROUTES.HOME}
      onClick={() =>
        // TODO: Verify correct analytics parameters
        trackAnalyticsEvent(EVENT_NAME.NAVIGATION_TAB_CLICKED, {
          screen_name: 'Navigation Bar',
          product_area: 'Navigation Bar',
          detail: 'Nav Bar Logo clicked',
          sub_detail: APP_MANAGED_ROUTES.HOME,
        })
      }
    >
      <img
        src={logoWithText}
        height="32px"
        alt={formatMessage({ id: 'STR_APP_NAME' })}
      />
    </TextAction>
  );
};

export const AppNavBarComponent = React.memo(() => {
  const { navLinks } = useNavLinksList();
  const { userSettingsLinks } = useUserSettingsLinksConfig();

  return (
    <ResponsiveHeaderNav
      navLinks={navLinks}
      logo={<Logo />}
      userSettingsLinks={userSettingsLinks}
    />
  );
});
